import React, { useEffect, useState, useRef, useMemo } from "react";
import './courseDetails.css';
import apiService from "../../../services/apiService";
import { useParams } from "react-router-dom";
import CustomToast from "../../Toast";
import Loader from "../../layouts/loader";
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from "react-modal";
import { useTranslation } from "react-i18next";

const CourseDetails = () => {
    const [courseDetails, setCourseDetails] = useState({})
    const [userInfo, setUserInfo] = useState({})
    const [loader, setLoader] = useState(false);
    const [expandedAccordian, setExpandedAccordian] = useState(0);
    const [expandAll, setExpandAll] = useState(false);
    const [showFullContent, setShowFullContent] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [showOverlay, setShowOverlay] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const videoRef = useRef(null);
    const limit = 350;
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const course = location.state?.course || location.state?.currentCourse

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    const { id } = useParams()
    const getCourseDetails = async (user_details) => {
        try {
            const token = apiService.getAuthToken();
            const response = await apiService.getLmsv1(`getModuleStatus?course_meta_id=${id}&user_id=${user_details?.uid}`, token);
            return response;
        } catch (error) {
            console.log(error);
            CustomToast.info('It seems your connection is slow. Please refresh the page or try again in sometime.');
            return;
        }
    }

    useEffect(() => {
        let user_details = sessionStorage.getItem('user_details')
        if (user_details) {
            user_details = JSON.parse(user_details)
            setUserInfo(user_details)
        }
        setLoader(true);
        getCourseDetails(user_details).then((data) => {
            if (data?.data?.moduleContent?.questions && (data?.data?.moduleContent?.course_test_type == 'end_line' || data?.data?.moduleContent?.course_test_type == 'base_line')) {
                data.data.moduleContent.questions = shuffleArray(data?.data?.moduleContent?.questions)
            }
            setCourseDetails(data?.data)
            setLoader(false);
        }).catch((error) => {
            console.log(error);
            setLoader(false);
            CustomToast.error(error);
        })
    }, [])

    const startCourseList = async (data) => {
        setLoader(true);
        try {
            let userLangs = sessionStorage.getItem("userLangArr")
            if (userLangs) {
                userLangs = JSON.parse(userLangs)
                const fetchData = userLangs.find(ele => ele?.course_id == data?.new_course_id)
                if (fetchData) {
                    localStorage.setItem('userLang', fetchData?.lang)
                }
            }
            const token = apiService.getAuthToken()
            await apiService.postLmsWithQuery(`startCourse?course_id=${data?.course_id}&user_id=${userInfo?.uid || "725e1bb6-77c7-4137-8482-0dc0fd74b14f"}`, token)
            localStorage.setItem("courseMetaId", data?.modules[0]?.course_meta_id)
            navigate(`/learning_space/course_modules/${data?.modules[0]?.course_meta_id}`);
            setLoader(false);
        } catch (error) {
            console.log("Error in starting course list:", error);
            setLoader(false);
            CustomToast.error('It seems your connection is slow. Please refresh the page or try again in sometime.');
        }
    }

    let course_meta_id
    if (courseDetails?.modules) {
        course_meta_id = courseDetails?.modules[0]?.course_meta_id;
        localStorage.setItem("courseMetaId", course_meta_id)
    }

    const handleExpandAccordian = (index) => {
        if (expandAll) {
            setExpandAll(false);
        } else {
            setExpandedAccordian(index === expandedAccordian ? -1 : index);
        }
    };

    const handleExpandAll = () => {
        setExpandAll(!expandAll);
        setExpandedAccordian(expandAll ? -1 : 0);
    };

    const continuesCourse = async (data) => {
        let userLangs = sessionStorage.getItem("userLangArr")
        if (userLangs) {
            userLangs = JSON.parse(userLangs)
            const fetchData = userLangs.find(ele => ele.course_id == data?.new_course_id)
            if (fetchData) {
                localStorage.setItem('userLang', fetchData?.lang)
            }
            navigate(`/learning_space/course_modules/${data?.course_meta_id}`)
        } else {
            navigate(`/learning_space/course_modules/${data?.course_meta_id}`)
        }
    }

    const totalSubModules = useMemo(() => {
        return courseDetails?.modules?.reduce(
            (acc, mod) => acc + (mod.sub_modules?.length || 0),
            0
        );
    }, [courseDetails]);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };


    const getInitials = (name) => {
        return name?.split(' ').map(word => word.charAt(0)).join('').toUpperCase() || '';
    };

    const langId = course?.lang == 'Hindi' ? 'hi' : 'en';
    const tForLang = i18n.getFixedT(langId);

    return (
        <>

            {loader ? <Loader />
                : <div className='page__main learning_course mt-lg-0 mt-5'>
                    <div className="learning_course_banner pt-lg-4 pt-5 position-relative ms-0 shadow-sm">

                        {courseDetails?.video ?
                            (<div className={`video-container learning_course_video ${showOverlay ? '' : ''}`}>
                                <img src={courseDetails?.banner_image || course?.banner_image} alt="banner" className="w-100 thumbnail_image" style={{ height: 'auto', maxHeight: "500px", objectFit: 'fill' }} />
                                <video ref={videoRef} className="w-100 thumbnail_video" style={{ height: 'auto', maxHeight: "500px", objectFit: 'fill', display: "none" }} >
                                    <source src={courseDetails?.video} type="video/mp4" />
                                </video>
                                <button id="playBtn" className={`${playing ? 'playing' : ''}`} onClick={() => openModal()}><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 180 180" fill="none"><g filter="url(#filter0_d_1545_54856)"><path d="M77.4505 113.254V55.3722L116.038 84.3132M90.3132 20C81.8674 20 73.5044 21.6635 65.7016 24.8955C57.8987 28.1276 50.8089 32.8649 44.8369 38.8369C32.7758 50.8979 26 67.2563 26 84.3132C26 101.37 32.7758 117.728 44.8369 129.789C50.8089 135.761 57.8987 140.499 65.7016 143.731C73.5044 146.963 81.8674 148.626 90.3132 148.626C107.37 148.626 123.728 141.85 135.789 129.789C147.85 117.728 154.626 101.37 154.626 84.3132C154.626 75.8674 152.963 67.5044 149.731 59.7016C146.499 51.8987 141.761 44.8089 135.789 38.8369C129.817 32.8649 122.728 28.1276 114.925 24.8955C107.122 21.6635 98.7589 20 90.3132 20Z" fill="white"></path></g><defs><filter id="filter0_d_1545_54856" x="0.718277" y="0.0407453" width="179.19" height="179.19" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"><feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="5.32247"></feOffset><feGaussianBlur stdDeviation="12.6409"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1545_54856"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1545_54856" result="shape"></feBlend></filter></defs></svg></button>
                            </div>) : (
                                <img src={courseDetails?.banner_image || course?.banner_image || "https://inclusional.s3.ap-south-1.amazonaws.com/project_dev/images/2025-08-13%2010:22:31-Safe%20Workplaces_Banner.png"} alt="banner" className="w-100 thumbnail_image" style={{ height: 'auto', maxHeight: "500px", objectFit: 'fill' }} />
                            )}
                        <Modal
                            isOpen={modalIsOpen}
                            onRequestClose={closeModal}
                            contentLabel="Video Modal"
                            className="course-video w-75"
                        > <button className="btn btn-link close-btn text-end w-100" onClick={closeModal}><svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                            <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                        </svg></button>
                            <div className="video-container">
                                <video
                                    ref={videoRef}
                                    controls
                                    autoPlay
                                    className="w-100"
                                    src={courseDetails?.video}
                                />
                            </div>
                        </Modal>

                        <div className={`banner-content ${course?.banner_image ? "banner-content" : "no-banner"}`}>
                            <div className="row  m-0">
                                <div className="col-lg-12 ms-auto">
                                    <div className="card p-2">
                                        <div className="card-body">
                                            <h3 className="font-weight-600 text-capitalize font-20">{courseDetails?.title}</h3>
                                            <p className='text-gray font-16 mb-2'> {courseDetails?.tagline || course?.tagline} </p>
                                            <p className='mb-0'>
                                                <span className="text-dark-gray text-capitalize pe-4"><img src="/images/time.svg" className="me-2" />{courseDetails?.duration} </span>
                                                <span className="text-dark-gray text-capitalize"><img src="/images/modules.png" className="me-2" />{courseDetails?.total_modules} {tForLang('course_information_sections')}</span>
                                            </p>
                                            {course?.completed_user_list?.length == 0 && course?.completion_percent != 100 && (course?.status == "notstarted" || course?.status == "inprogress") ?
                                                <div className="my-4">
                                                    <p className="mb-0"><img src="/images/account.svg" className="mb-2" style={{ height: "28px", width: "28px", borderRadius: "50%" }} /></p>
                                                    <p className='my-3'>{tForLang('home_page_first_one_to_complete')}</p>
                                                </div>
                                                : course?.completed_user_list?.length > 1 && course?.completed_user_list?.length <= 10 && course?.completion_percent == 100 && course?.status == "completed" ?
                                                    <div className="my-4"> <div className='d-flex justify-content-start align-items-start ms-2'>
                                                        {course?.completed_user_list?.slice(0, 5).map((user, index) => {
                                                            return (
                                                                <span className="mb-2" key={index}>
                                                                    {user?.pic && user?.pic !== "null" && user?.pic !== null ? (
                                                                        <img src={user?.pic} className="mb-2 me-0" style={{ height: "28px", width: "28px", borderRadius: "50%" }} />
                                                                    ) : (
                                                                        <span className='course-card-initials fw-bolder font-28 mb-2 me-0 text-white'>{getInitials(user?.name)}</span>
                                                                    )}
                                                                </span>
                                                            );
                                                        })}
                                                        {course?.total_completed_users > 5 && (
                                                            <span className="mb-2 count-circle">
                                                                {course?.total_completed_users - 1}+
                                                            </span>
                                                        )}
                                                    </div>
                                                        <p>{tForLang('home_page_congrates')}</p>
                                                    </div>
                                                    : course?.completed_user_list?.length === 1 && course?.completion_percent == 100 && course?.status == "completed" ?
                                                        <div className="my-4">
                                                            <div className='d-flex justify-content-start align-items-start ms-2'>
                                                                {course?.completed_user_list?.slice(0, 5).map((user, index) => {
                                                                    return (
                                                                        <span className="mb-2" key={index}>
                                                                            {user?.pic && user?.pic !== "null" && user?.pic !== null ? (
                                                                                <img src={user?.pic} className="mb-2 me-0" style={{ height: "28px", width: "28px", borderRadius: "50%" }} />
                                                                            ) : (
                                                                                <span className='course-card-initials fw-bolder font-28 mb-2 me-0 text-white'>{getInitials(user?.name)}</span>
                                                                            )}
                                                                        </span>
                                                                    );
                                                                })}
                                                                {course?.total_completed_users > 5 && (
                                                                    <span className="mb-2 count-circle">
                                                                        {course?.total_completed_users - 1}+
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <p>{tForLang('home_page_you_are_first_one_to_complete')}</p>
                                                            {/* <p>You are among the top 10 <span>{course?.completed_user_list?.length > 0 && course?.completed_user_list?.length !== 1 ? 'employees' : 'employee'}</span> to complete the course</p> */}
                                                        </div> :
                                                        <div className="my-4"><div className='d-flex justify-content-start align-items-start ms-2'>
                                                            {course?.completed_user_list?.slice(0, 5).map((user, index) => {
                                                                return (
                                                                    <span className="mb-2" key={index}>
                                                                        {user?.pic && user?.pic !== "null" && user?.pic !== null ? (
                                                                            <img src={user?.pic} className="mb-2 me-0" style={{ height: "28px", width: "28px", borderRadius: "50%" }} />
                                                                        ) : (
                                                                            <span className='course-card-initials fw-bolder font-28 mb-2 me-0 text-white'>{getInitials(user?.name)}</span>
                                                                        )}
                                                                    </span>
                                                                );
                                                            })}
                                                            {course?.total_completed_users > 5 && (
                                                                <span className="mb-2 count-circle">
                                                                    {course?.total_completed_users - 1}+
                                                                </span>
                                                            )}
                                                        </div>
                                                            <p>{course?.total_completed_users} <span>{course?.completed_user_list?.length > 0 && course?.completed_user_list?.length !== 1 ? tForLang('home_page_employees') : tForLang('home_page_employee')}</span> {tForLang('home_page_employees_completed_course')}</p>
                                                        </div>
                                            }

                                            {courseDetails && courseDetails?.status == 'notstarted' ? <div>
                                                <button type="button" className="btn btn-md btn-primary w-100"
                                                    onClick={() => startCourseList(courseDetails)}
                                                >{tForLang('home_page_get_started')}</button>
                                            </div> : courseDetails?.status == 'inprogress' ?
                                                // null
                                                <div>
                                                    <button type="button" className="btn btn-md btn-primary w-100" onClick={() => continuesCourse(course)}>{tForLang('home_page_continue_course')}</button>
                                                </div> :
                                                <div>
                                                    <button type="button" className="btn btn-md btn-primary w-100" onClick={() => continuesCourse(course)}>{tForLang('home_page_completed')}</button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row m-0 bg-white p-lg-4">
                        <div className="col-md-10 p-3 ms-0">
                            <div className={`course-content my-4 ${course?.banner_image ? "course-content" : "without-banner"}`}>
                                <div dangerouslySetInnerHTML={{ __html: courseDetails?.contents?.[1] }} />
                            </div>
                            <h3 className="fw-bold font-20">{tForLang('course_information_course_content')}</h3>
                            <div className="d-flex justify-content-between align-items-start py-3">
                                <p className="course-info-wrapper">
                                    <span className="course-info-item small">
                                        <img src="/images/section.svg" alt="section" />
                                        <span>{courseDetails?.total_modules} {tForLang('course_information_sections')}</span>
                                    </span>
                                    <span className="course-info-item with-border small">
                                        <img src="/images/lecture.svg" alt="lecture" />
                                        <span>{totalSubModules} {tForLang('course_information_lectures')}</span>
                                    </span>
                                    <span className="course-info-item with-border small">
                                        <img src="/images/time copy.svg" alt="time-copy" />
                                        <span>{courseDetails?.duration} {tForLang('course_information_total_length')}</span>
                                    </span>
                                </p>
                                <p className="text-end" style={{ width: '27%' }}>
                                    <a
                                        href="javascript:void(0)"
                                        className="fw-bold text-decoration-none"
                                        onClick={handleExpandAll}
                                    >
                                        {expandAll
                                            ? tForLang('course_information_collapse_all_the_sections')
                                            : tForLang('course_information_expand_all_the_sections')
                                        }
                                    </a>
                                </p>
                            </div>

                            <div className="accordion" id="accordionExample">
                                {courseDetails?.modules && courseDetails?.modules?.map((module, i) => {
                                    return <div className={`accordion-item ${expandAll || i === expandedAccordian ? 'show' : ''}`} key={i}>
                                        <h2 className="accordion-header" id={i}>
                                            <button onClick={() => handleExpandAccordian(i)} className="accordion-button py-lg-4 py-3 ps-lg-4 ps-0" type="button" data-bs-toggle="collapse" data-bs-target={'#' + module?.title} aria-expanded={expandAll || i === expandedAccordian} aria-controls={module?.title}>
                                                <span className="fw-bold font-18 text-capitalize ms-2">
                                                    {tForLang('course_information_section')} {i + 1} : {module?.title}</span>
                                                <span className="ms-auto text-capitalize"><img src="/images/lecture_white.svg" alt="time-copy" /> {module?.sub_modules.length} {tForLang('course_information_lectures')} </span>
                                                {/* <span className="ms-auto">{module?.total_lectures} Lectures . {module?.duration} mins</span> */}
                                            </button>
                                        </h2>
                                        <div id={module?.title} className={`accordion-collapse collapse ${i === expandedAccordian ? 'show' : ''}`} aria-labelledby={i} data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <ul>
                                                    {module?.sub_modules && module?.sub_modules.map(submodule => {
                                                        return <li className="d-flex flex-column justify-content-between align-items-start mb-lg-3 mb-2">

                                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                                <span>
                                                                    {submodule?.module_type == "video" ?
                                                                        <img src="/images/video.svg" alt="video" className='module-icon me-2' /> : submodule?.module_type == "test" ? <img src="/images/quiz.svg" alt="quiz" className='module-icon me-2' /> : <img src="/images/notes.svg" alt="notes" className='module-icon me-2' />}
                                                                    <span className="font-16">
                                                                        {submodule?.title}
                                                                    </span>
                                                                </span>
                                                                <span className="text-dark-gray">{/*submodule?.duration*/}</span>
                                                            </div>

                                                            {submodule?.sub_sub_modules && (
                                                                <ul id={submodule?.title} className={`nestedsubmodule ps-3 w-100 accordion-collapse collapse `}>
                                                                    {submodule?.sub_sub_modules?.map((nestedSubModule) => (
                                                                        <li key={nestedSubModule?.id} className={`my-lg-3 my-2 pt-1 ps-3 w-100`}>
                                                                            <div className={`font-16 text-dark-grey text-decoration-none d-flex justify-content-between align-items-center`} >
                                                                                <span>
                                                                                    {submodule?.module_type == "video" ?
                                                                                        <img src="/images/video.svg" alt="video" className='module-icon me-2' /> : submodule?.module_type == "test" ? <img src="/images/quiz.svg" alt="quiz" className='module-icon me-2' /> : <img src="/images/notes.svg" alt="notes" className='module-icon me-2' />}
                                                                                    {nestedSubModule?.title}
                                                                                </span>
                                                                                <span className="text-dark-gray">{/*nestedSubModule?.duration*/}</span>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </li>
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default CourseDetails;